module.exports = __webpack_public_path__ + "static/media/chatIcon.0c0778bc.svg";